import { useContext, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { UserContext } from '../context/userContext';
import {
  MonthlyLimitHookReturn,
  MonthlyLimitPrescriptionProps,
  MonthlyLimitProductsProps,
} from '../interface/interface';
import { productDefaultColors } from '../constant/constant';
import instance from '../config/axios';

function processProductData(
  productData: MonthlyLimitPrescriptionProps[],
  productFrameProducts: MonthlyLimitProductsProps[],
  productDefaultColors: string[],
) {
  for (let i = 0; i <= productData.length; i++) {
    if (i === productData.length) {
      const total = productData[0]?.total;
      const consumedSum: number = productData
        ?.map((ele: { consumed: number }) => ele.consumed)
        ?.reduce((x: number, y: number) => x + y, 0);

      productFrameProducts.push({
        name: 'Qty remaining',
        value:
          productData?.length === 0
            ? (total ?? 0)
            : total
              ? total - consumedSum
              : 0,
        fill: '#F3F4F6',
      });
      continue;
    }
    productFrameProducts.push({
      name: productData[i].product_name,
      value: productData[i].consumed,
      fill: productDefaultColors[i],
      subProducts: productData[i]?.substituteProducts,
    });
  }
}

const useMonthlyLimitActions = (): MonthlyLimitHookReturn => {
  const { user } = useAuth();
  const { userDetail } = useContext(UserContext);
  const [load, setLoad] = useState(false);
  const [driedFlowerPrescriptions, setDriedFlowerPrescriptions] = useState<
    MonthlyLimitPrescriptionProps[] | []
  >([]);
  const [vapeCartridgePrescriptions, setVapeCartridgePrescriptions] = useState<
    MonthlyLimitPrescriptionProps[] | []
  >([]);
  const [driedFlowerProducts, setDriedFlowerProducts] = useState<
    MonthlyLimitProductsProps[] | []
  >([]);
  const [vapeCartridgeProducts, setVapeCartridgeProducts] = useState<
    MonthlyLimitProductsProps[] | []
  >([]);

  const callMonthlyLimit = async () => {
    try {
      const token = user?.access_token;

      const response = await instance.get('api/v1/monthly-limit-products', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const driedFlowerData: MonthlyLimitPrescriptionProps[] =
        response?.data?.driedFlower?.filter(
          (x: { consumed: number }) => x.consumed !== 0,
        );

      const vapeCartridgeData: MonthlyLimitPrescriptionProps[] =
        response?.data?.vapeCartridge?.filter(
          (x: { consumed: number }) => x.consumed !== 0,
        );

      setDriedFlowerPrescriptions(driedFlowerData);
      setVapeCartridgePrescriptions(vapeCartridgeData);

      const driedProductsframeProducts: MonthlyLimitProductsProps[] | [] = [];
      const vapeCartridgeProductsframeProducts:
        | MonthlyLimitProductsProps[]
        | [] = [];

      processProductData(
        driedFlowerData,
        driedProductsframeProducts,
        productDefaultColors,
      );

      processProductData(
        vapeCartridgeData,
        vapeCartridgeProductsframeProducts,
        productDefaultColors,
      );

      setDriedFlowerProducts(driedProductsframeProducts);
      setVapeCartridgeProducts(vapeCartridgeProductsframeProducts);

      setLoad(false);
    } catch (error) {
      console.error(error);
      setLoad(false);
    }
  };

  useEffect(() => {
    setLoad(true);
    callMonthlyLimit();
  }, []);

  return [
    load,
    userDetail,
    {
      chartData: driedFlowerProducts,
      prescriptions: driedFlowerPrescriptions,
    },
    {
      chartData: vapeCartridgeProducts,
      prescriptions: vapeCartridgePrescriptions,
    },
  ];
};

export default useMonthlyLimitActions;
